"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  social: {
    rssFeed: '/feed/atom/',
    twitterHandle: '@RadioTimes',
    facebookProfile: 'radiotimes',
    youtubeChannel: 'UC1IA2x0IazEVqAG5_WjxBAg',
    instagramProfile: 'radiotimes',
    pinterestProfile: 'rtonline'
  },
  header: {
    logo: 'primary',
    eyebrowLogo: 'primary',
    eyebrowColour: 'dark',
    backgroundColour: 'dark',
    navigationAlignment: 'left'
  },
  siteIdentity: {
    logo: {
      url: 'https://images.immediate.co.uk/production/volatile/sites/3/2021/07/radiotimescom-logo2-2c180e8.png',
      alt: 'The Radio Times logo',
      width: 800,
      height: 151
    },
    secondaryLogo: {
      url: 'https://images.immediate.co.uk/production/volatile/sites/3/2017/08/cropped-radiotimes-header-logo-ad1202c.png',
      alt: 'The Radio Times logo',
      width: 265,
      height: 55
    }
  },
  siteConfig: {
    search: {
      placeholder: 'Series, Movies, Games...'
    },
    verification: {
      facebook: 'u4ylx6xopb5vy1edoq8hy242v9y83x'
    }
  },
  tracking: {
    ampGtmId: 'GTM-NZDN3N5',
    ampGtmEnv: 'gtm_auth=uCwWhqzMY7jwQ2Z9e3Cdfw&gtm_preview=env-2'
  },
  general: {
    siteTitle: 'Radio Times'
  },
  enableAmpOnPostType: {
    post: true,
    editorialList: true,
    recipe: true
  }
};
exports["default"] = _default;